document.addEventListener('DOMContentLoaded', function () {
	const load_btn = document.querySelector(".custom-filter-load-more");
	let products_on_page = document.querySelector('.collection-grid');
	let url = products_on_page.getAttribute('data-next-url');
	const spinner = document.querySelector('.load-more-spinner');
	//const viewOptions = document.querySelectorAll('.view-options > div');
	const tabs = document.querySelectorAll('.collection-filter .tab');
	const filters = document.querySelectorAll('.collection-filter');
	let productCards = products_on_page.querySelectorAll('.product-card');

	// Function to get URL parameter value
	function getUrlParameter(name) {
		name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
		const regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
		const results = regex.exec(location.search);
		return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
	}

	// Initialize filters based on URL parameter
	const filterParam = getUrlParameter('filter');
	if (filterParam) {
		filters.forEach(filter => {
			const activeTab = filter.querySelector(`.tab[data-id="${filterParam}"]`);
			if (activeTab) {
				handleTabClick(activeTab, filter);
			}
		});
	}

	// viewOptions.forEach((option) => {
	//     option.addEventListener('click', function(e) {
	//         e.preventDefault();

	//         const dataColumns = option.getAttribute('data-columns');

	//         viewOptions.forEach((option) => { option.classList.remove('active') });
	//         option.classList.add('active');

	//         products_on_page.classList.remove(`columns-3`);
	//         products_on_page.classList.remove(`columns-2`);
	//         products_on_page.classList.add(`columns-${dataColumns}`);
	//     });
	// });

	// Handle tab clicks
	tabs.forEach(tab => {
		tab.addEventListener('click', function () {
			const filter = this.closest('.collection-filter');
			handleTabClick(this, filter);

			// Update URL parameter
			const dataId = this.getAttribute('data-id');
			const newUrl = new URL(window.location);
			newUrl.searchParams.set('filter', dataId);
			window.history.pushState({}, '', newUrl);
		});
	});

	// Initialize tabs on load if no URL parameter is set
	if (!filterParam) {
		filters.forEach(filter => {
			const activeTab = filter.querySelector('.tab.active');
			if (activeTab) {
				handleTabClick(activeTab, filter);
			}
		});
	}

	// Load more products
	if (load_btn) {
		if (url === '') {
			load_btn.style.display = 'none';
		}

		load_btn.addEventListener("click", () => {

			spinner.classList.add("show");

			fetch(url)
				.then(function (response) {
					if (response.ok) {
						return response.text();
					} else {
						throw new Error('Network response was not ok.');
					}
				})
				.then(function (data) {
					const html = document.createElement('div');
					html.innerHTML = data;

					let links = html.querySelector('.pagination-links').innerHTML;
					document.querySelector('.pagination-links').innerHTML = links;

					let new_grid = html.querySelector('.collection-grid');
					url = new_grid.getAttribute('data-next-url');
					if (url === '') {
						load_btn.style.display = 'none';
					}
					let new_products = new_grid.querySelectorAll(".product-card, #collection-grid-cta, #collection-grid-cta-2");

					new_products.forEach(new_prod => {
						products_on_page.append(new_prod);
					});
					spinner.classList.remove("show");
				})
				.catch(function (error) {
					window.log(error);
				});
		})
	}

	// Handle tab click functionality
	function handleTabClick(tab, filter) {
		const dataId = tab.getAttribute('data-id');
		const tabs = filter.querySelectorAll('.tab');

		tabs.forEach(tab => tab.classList.remove('active'));
		tab.classList.add('active');

		filterProducts(dataId);
		updateActiveTabBackground(filter);
	}

	// Filter product cards based on the selected tab
	function filterProducts(filter) {
		productCards.forEach(card => {
			const filters = card.getAttribute('data-filter').split(',');

			if (filter === 'all' || filters.includes(filter)) {
				card.style.display = 'flex';
			} else {
				card.style.display = 'none';
			}
		});
	}

	function updateActiveTabBackground(filter) {
		const tabsContainer = filter.querySelector('.tabs');
		const activeTab = tabsContainer.querySelector('.tab.active');
		const tabRow = activeTab.closest('.tab-row');
		const activeLeft = activeTab.offsetLeft;
		const tabRowLeft = tabRow.getBoundingClientRect().left;
		const tabsContainerLeft = tabsContainer.getBoundingClientRect().left;
		const activeTop = tabRow.offsetTop + activeTab.offsetTop;
		const activeWidth = activeTab.offsetWidth;

		tabsContainer.style.setProperty('--active-tab-left', `${activeLeft + tabRowLeft - tabsContainerLeft}px`);
		tabsContainer.style.setProperty('--active-tab-top', `${activeTop}px`);
		tabsContainer.style.setProperty('--active-tab-width', `${activeWidth}px`);
	}

	// const productCardSwipers = document.querySelectorAll('.product-card .swiper-container');
	// productCardSwipers.forEach((swiperContainer) => {
	//     new window.swiper(swiperContainer, {
	//         // Swiper settings
	//         loop: true,
	//         pagination: {
	//             el: `.swiper-pagination`,
	//             clickable: true,
	//             dynamicBullets: true,
	//             dynamicMainBullets: 5
	//         },
	//         lazy: true,
	//     });
	// });
});
